import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import {
  RequestStatus, 
  InstrumentPriceBarT,
  MarketStateT,
  InstrumentT,
  CurrencyT,
  PriceT,
} from 'types';

export const initialMarketState: MarketStateT = {
  instruments: [],
  instrumentsStatus: RequestStatus.None,
  selectedInstrument: null,
  selectedInstrumentPrice: null,
  selectedInstrumentPriceStatus: RequestStatus.None,
  instrumentPriceBars: [],
  instrumentPriceBarsStatus: RequestStatus.None,
  currencies: [],
  currenciesStatus: RequestStatus.None,
  prices: [],
  pricesStatus: RequestStatus.None,
};

const marketSlice = createSlice({
  name: 'market',
  initialState: initialMarketState,
  reducers: {
    setMarketInstruments(state, action: PayloadAction<InstrumentT[]>) {
      state.instruments = action.payload;
    },
    setSelectedInstrument(state, action: PayloadAction<string>) {
      const instrument =
        state.instruments.find((i: InstrumentT) => i.instrument_id === action.payload) || state.instruments[0];
      state.selectedInstrument = instrument;
    },
    setMarketInstrumentsStatus(state, action: PayloadAction<RequestStatus>) {
      state.instrumentsStatus = action.payload;
    },
    setSelectedInstrumentPrice(state, action: PayloadAction<InstrumentPriceBarT>) {
      state.selectedInstrumentPrice = action.payload;
    },
    setSelectedInstrumentPriceStatus(state, action: PayloadAction<RequestStatus>) {
      state.selectedInstrumentPriceStatus = action.payload;
    },
    setInstrumentPriceBars(state, action: PayloadAction<InstrumentPriceBarT[]>) {
      state.instrumentPriceBars = action.payload;
    },
    setInstrumentPriceBarsStatus(state, action: PayloadAction<RequestStatus>) {
      state.instrumentPriceBarsStatus = action.payload;
    },
    setMarketCurrencies(state, action: PayloadAction<CurrencyT[]>) {
      state.currencies = action.payload;
    },
    setMarketCurrenciesStatus(state, action: PayloadAction<RequestStatus>) {
      state.currenciesStatus = action.payload;
    },
    setMarketPrices(state, action: PayloadAction<PriceT[]>) {
      state.prices = action.payload;
    },
    setMarketPricesStatus(state, action: PayloadAction<RequestStatus>) {
      state.pricesStatus = action.payload;
    },
  },
});

export const {
  setMarketInstruments,
  setSelectedInstrument,
  setMarketInstrumentsStatus,
  setInstrumentPriceBars,
  setInstrumentPriceBarsStatus,
  setMarketCurrencies,
  setMarketCurrenciesStatus,
  setMarketPrices,
  setMarketPricesStatus,
  setSelectedInstrumentPrice,
  setSelectedInstrumentPriceStatus,
} = marketSlice.actions;

export default marketSlice.reducer;
